import { Sparkles, Search, FileText, ShieldCheck } from "lucide-react";
import SEOHead from "@/components/SEOHead";
import SeoMetaGenerator from "@/components/SeoMetaGenerator";
import ToolPageShell from "@/components/tools/ToolPageShell";

const faqs = [
  { q: "Does it follow Google's length limits?", a: "Yes — titles are capped at 60 characters and meta descriptions at 155, matching Google's typical SERP truncation." },
  { q: "What does it generate?", a: "Title, meta description, slug, H1, keywords, Open Graph and Twitter tags, plus a JSON-LD WebPage schema you can paste into your <head>." },
  { q: "Can I tweak the brand voice?", a: "Absolutely — describe your audience and tone in the prompt (e.g. 'friendly, plain-spoken, no buzzwords')." },
  { q: "Will it know my brand?", a: "Only what you include in the prompt. Add brand name, USPs and voice notes for best results." },
];

const SeoMetaGeneratorPage = () => (
  <>
    <SEOHead
      title="Free AI SEO Meta Generator — Title, Description, Schema"
      description="Generate SEO titles, meta descriptions, Open Graph, Twitter tags and JSON-LD from a short page description. Free, AI-powered."
      path="/tools/seo-meta-generator"
      keywords="SEO meta generator, AI meta description, title tag generator, open graph generator, JSON-LD generator, free SEO tool"
      breadcrumbs={[
        { name: "Home", path: "/" },
        { name: "Free Tools", path: "/tools" },
        { name: "SEO Meta Generator", path: "/tools/seo-meta-generator" },
      ]}
      jsonLd={[
        { "@context": "https://schema.org", "@type": "WebApplication", name: "NETIUS SEO Meta Generator", url: "https://netius.com/tools/seo-meta-generator", applicationCategory: "DeveloperApplication", operatingSystem: "Any (Web)", offers: { "@type": "Offer", price: "0", priceCurrency: "USD" } },
        { "@context": "https://schema.org", "@type": "FAQPage", mainEntity: faqs.map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.a } })) },
      ]}
    />
    <ToolPageShell
      title="SEO Meta Generator"
      subtitle="Describe your page in a sentence. Get a complete, character-limited SEO bundle: title, description, slug, H1, social tags and JSON-LD."
      badges={[
        { icon: Sparkles, label: "AI-powered" },
        { icon: Search, label: "SERP-safe limits" },
        { icon: ShieldCheck, label: "Nothing stored" },
      ]}
      featuresHeading="What it does"
      features={[
        { icon: FileText, title: "Full meta bundle", description: "Title, description, slug, H1, Open Graph and Twitter tags in one click." },
        { icon: Search, title: "Within Google's limits", description: "Titles ≤60 chars, descriptions ≤155 — built to survive SERP truncation." },
        { icon: Sparkles, title: "JSON-LD included", description: "Schema.org WebPage markup ready to paste into your <head>." },
      ]}
      faqSubheading="Quick answers about the SEO meta generator."
      faqs={faqs}
      softCtaText="Want a full SEO audit and content plan for your site?"
    >
      <SeoMetaGenerator />
    </ToolPageShell>
  </>
);

export default SeoMetaGeneratorPage;